import React from 'react';
import { Box, Link as MuiLink, Typography } from '@mui/material';
import { ContentUseCase } from '../../corelogic/usecases/ContentUseCase';
import { useLanguage } from '../../shared/contexts/LanguageContext';
import { SEO } from './SEO';
import { Section, PageHeader } from './PageSection';
import { LegalBlock, LegalHeading } from './LegalSectionBody';

const contentUseCase = new ContentUseCase();

export const ImpressumPage: React.FC = () => {
  const { language } = useLanguage();
  const { impressum } = contentUseCase.getLegalContent(language);

  return (
    <Box>
      <SEO page="impressum" />

      <PageHeader title={impressum.title} />

      <Section maxWidth="md">
        <LegalBlock>
          <LegalHeading>{impressum.contact.title}</LegalHeading>
          <Typography variant="body1" paragraph>
            {impressum.contact.description}
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {impressum.contact.name}
          </Typography>
          <Typography variant="body1">{impressum.contact.address}</Typography>
          <Typography variant="body1">{impressum.contact.city}</Typography>
          <Typography variant="body1">{impressum.contact.country}</Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            {impressum.contact.emailLabel}{' '}
            <MuiLink href={`mailto:${impressum.contact.email}`} sx={{ color: 'primary.dark' }}>
              {impressum.contact.email}
            </MuiLink>
          </Typography>

          <Typography variant="h6" component="h3" sx={{ mt: 4, mb: 1 }}>
            {impressum.contact.responsibleTitle}
          </Typography>
          <Typography variant="body1">{impressum.contact.responsible}</Typography>

          <Typography variant="body1" sx={{ mt: 3, color: 'text.secondary' }}>
            {impressum.contact.legalFormNote}
          </Typography>
        </LegalBlock>

        <LegalBlock>
          <LegalHeading>{impressum.purpose.title}</LegalHeading>
          <Typography variant="body1" paragraph>
            {impressum.purpose.description}
          </Typography>
          <Typography variant="body1" paragraph>
            {impressum.purpose.goal}
          </Typography>
        </LegalBlock>

        <LegalBlock>
          <LegalHeading>{impressum.disclaimer.title}</LegalHeading>
          <Typography variant="h6" component="h3" sx={{ mt: 3, mb: 1 }}>
            {impressum.disclaimer.medical.title}
          </Typography>
          <Typography variant="body1" paragraph>
            {impressum.disclaimer.medical.text}
          </Typography>
          <Typography variant="h6" component="h3" sx={{ mt: 3, mb: 1 }}>
            {impressum.disclaimer.external.title}
          </Typography>
          <Typography variant="body1" paragraph>
            {impressum.disclaimer.external.text}
          </Typography>
        </LegalBlock>

        <LegalBlock>
          <LegalHeading>{impressum.copyright.title}</LegalHeading>
          <Typography variant="body1" paragraph>
            {impressum.copyright.description}
          </Typography>
          <Typography variant="body1" paragraph>
            {impressum.copyright.images}
          </Typography>
        </LegalBlock>

        <LegalBlock last>
          <LegalHeading>{impressum.dispute.title}</LegalHeading>
          <Typography variant="body1">{impressum.dispute.text}</Typography>
        </LegalBlock>
      </Section>
    </Box>
  );
};
